<div [ngClass]="{'btn-events-one': isButtonsViewType}">
    <app-booking-type [description]="description" [additionalDescription]="additionalDescription" [viewType]="viewType"
    [title]="areaItemPack.name" [maxLenNamePack]="maxLenNamePack" (click)="areaItemPackClick(areaItemPack)">
  </app-booking-type>
</div>
